// TODO: rewrite this file to reduce code repetition
import { hostFactory as hostInstance } from "../factory";

const pathname = "groups";
const suffix = "/api/companies";

const getGroups = companyId =>
  hostInstance.get(`${suffix}/${companyId}/${pathname}`);

const getTrainees = companyId =>
  hostInstance.get(`${suffix}/${companyId}/${pathname}/trainees`);

const getManagers = companyId =>
  hostInstance.get(`${suffix}/${companyId}/${pathname}/managers`);

const addGroup = (companyId, group) =>
  hostInstance.post(`${suffix}/${companyId}/${pathname}`, group);

const getGroupById = (companyId, groupId) =>
  hostInstance.get(`${suffix}/${companyId}/${pathname}/${groupId}`);

const updateGroup = ({ companyId, groupId, data }) =>
  hostInstance.put(
    `${suffix}/${companyId}/${pathname}/${groupId}`,
    data
  );

const toggleGroups = ({ companyId, groupId, toggler }) =>
  hostInstance.patch(
    `${suffix}/${companyId}/${pathname}/${groupId}/${toggler}`
  );

const deleteGroup = (companyId, groupId) =>
  hostInstance.delete(`${suffix}/${companyId}/${pathname}/${groupId}`);

export {
  addGroup,
  getTrainees,
  getManagers,
  getGroupById,
  deleteGroup,
  updateGroup,
  toggleGroups
};

export default getGroups;
